var pug = require("!../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (fieldsetCounter, globals, id) {
      






































































































pug_mixins["checkbox"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key
}
if (!attributes.attributes) {
attributes.attributes = {}
}
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": "checkbox schema-form-checkbox"},attributes.groupAttributes]), true)) + "\u003E\u003Cinput" + (pug.attrs(pug.merge([{"class": pug.classes([attributes.fieldHtmlClass], [true]),"type": "checkbox","ng-model": pug.escape(attributes.key),"ng-disabled": pug.escape(attributes.readonly),"id": pug.escape(id),"name": pug.escape(id),"required": pug.escape(attributes.required),"ng-true-value": pug.escape(attributes['ng-true-value']),"ng-false-value": pug.escape(attributes['ng-false-value']),"data-cy": pug.escape(attributes['data-cy'])},attributes.attributes]), true)) + "\u003E\u003Clabel" + (pug.attr("class", pug.classes([attributes.labelHtmlClass], [true]), false, true)+pug.attr("for", id, true, true)) + "\u003E\u003Cspan\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E";
};




















































pug_mixins["radio"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.title && attributes.name) {
attributes.title = attributes.name
}
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key + '-' + attributes.index
}
pug_html = pug_html + "\u003Cinput" + (pug.attr("class", pug.classes([attributes.fieldHtmlClass], [true]), false, true)+pug.attr("id", id, true, true)+" type=\"radio\""+pug.attr("required", attributes.required, true, true)+pug.attr("name", attributes.key, true, true)+pug.attr("ng-model", attributes.key, true, true)+pug.attr("ng-disabled", attributes.readonly, true, true)+pug.attr("value", attributes.value, true, true)+pug.attr("ng-value", attributes['ng-value'], true, true)+pug.attr("data-cy", attributes['data-cy'], true, true)+pug.attr("ng-change", attributes['ng-change'], true, true)) + "\u003E";
if (attributes.title) {
pug_html = pug_html + "\u003Clabel" + (" class=\"radio-inline\""+pug.attr("for", attributes.key + '-' + attributes.index, true, true)) + "\u003E\u003Cspan\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E";
}
};






































































pug_mixins["validationMessages"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.formname) {
attributes.formname = globals.formname
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-messages", attributes.formname +'['+ attributes.key +'].$error', false, true)) + "\u003E";
// iterate attributes.validationMessages
;(function(){
  var $$obj = attributes.validationMessages;
  if ('number' == typeof $$obj.length) {
      for (var condition = 0, $$l = $$obj.length; condition < $$l; condition++) {
        var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var condition in $$obj) {
      $$l++;
      var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
if (!fieldsetCounter) {
fieldsetCounter = 0
}





















pug_html = pug_html + "\u003Cdiv class=\"checkout_zusammenfassung-wrapper\"\u003E\u003Cdiv class=\"row video-row\"\u003E\u003Cdiv class=\"columns\"\u003E\u003Ca class=\"pagetitle\" href=\"https:\u002F\u002Fplayer.vimeo.com\u002Fvideo\u002F397982616?dnt=1\" magnific-popup=\"{type: 'iframe', clicker: clicker}\"\u003E\u003Ci class=\"font-icon font-icon-alt icon-play\"\u003E\u003C\u002Fi\u003EWie funktioniert der Beantragungsprozess?\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"bigbox centered\"\u003E\u003Cdiv class=\"header\"\u003E\u003Cspan\u003EZusammenfassung\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"main\"\u003E\u003Cdiv class=\"mainWrapper\"\u003E\u003Cspan class=\"error\" ng-click=\"goBack()\" ng-show=\"ZusammenfassungCtrl.mppTypeError\"\u003EDas Bestellverfahren für PC-Leasing wurde geändert. Kehren Sie mit Klick auf diese Nachricht in die Bausteinauswahl zurück und entfernen Sie rechts im Seitenmenü den Baustein PC-Leasing. Gehen Sie sodann in den PC-Leasing Shop und starten den Abruf für PC-Leasing neu. Sie werden direkt in die neue Abschlussstrecke geleitet. Sollten Sie Probleme haben, wenden Sie sich bitte an unser Team unter mpp@valuenet.de mit dem Stichwort \"Umstellung PC-Leasing\". Vielen Dank.\u003C\u002Fspan\u003E\u003Ch3\u003ESie möchten nachfolgende Bausteine nutzen:\u003C\u002Fh3\u003E\u003Cdiv class=\"margin-top-big\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-hide=\"ZusammenfassungCtrl.hasComponents()\"\u003EEs wurden noch keine Bausteine gewählt\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-repeat=\"component in ZusammenfassungCtrl.employee.components\"\u003E\u003Cdiv class=\"columns medium-6\"\u003E{{ component.name }}\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-6 right-text\"\u003E{{ component.component.value | currency }}\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cp class=\"margin-top-big\"\u003EMit dieser Optimierung können Sie einen Jahresvorteil von {{ (\n  ZusammenfassungCtrl.employee.result.final.tax.net_netto -\n  ZusammenfassungCtrl.employee.result.before.tax.net_netto +\n  ZusammenfassungCtrl.employee.result.final.tax.net_jahr\n) *12 | currency }} erreichen.\u003C\u002Fp\u003E\u003Cp class=\"margin-top-big\"\u003E\u003Cp\u003EWir möchten Sie darauf aufmerksam machen, dass sich durch diese Optimierung Ansprüche an die gesetzliche Versorgungsträger reduzieren. Im Fokus steht hier die Absicherung im längeren Krankheitsfall, Minderung von Arbeitslosengeld I Ansprüchen sowie die Auswirkung auf Ihre Rente.\u003C\u002Fp\u003E\u003C\u002Fp\u003E\u003Cdiv class=\"margin-top-big\"\u003E&nbsp;\u003C\u002Fdiv\u003E\u003Ch3\u003EIn Zahlen bedeutet das folgende Versorgungslücken:\u003C\u002Fh3\u003E\u003Cdiv class=\"row margin-top-big\"\u003E\u003Cdiv class=\"columns medium-6\"\u003EBei der gesetzl. Rente (je Optimierungsjahr)\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-6 right-text\"\u003E\u003Cspan ng-if=\"!ZusammenfassungCtrl.neoProject.project.compensationRente &amp;&amp; ZusammenfassungCtrl.employee.result.final.gap.rente != 0 &amp;&amp; ( ZusammenfassungCtrl.employee.result.final.gap.rente_ausgleich &gt;= ZusammenfassungCtrl.employee.result.final.gap.rente )\"\u003EKompensiert\u003C\u002Fspan\u003E\u003Cspan class=\"red\" ng-if=\"ZusammenfassungCtrl.neoProject.project.compensationRente || ZusammenfassungCtrl.employee.result.final.gap.rente == 0 || !( ZusammenfassungCtrl.employee.result.final.gap.rente_ausgleich &gt;= ZusammenfassungCtrl.employee.result.final.gap.rente )\"\u003E{{ (ZusammenfassungCtrl.employee.result.final.gap.rente \u002F ZusammenfassungCtrl.yearsToPension ) | currency }}\u003C\u002Fspan\u003E\u003Cspan ng-if=\"ZusammenfassungCtrl.neoProject.project.compensationRente || ZusammenfassungCtrl.employee.result.final.gap.rente == 0 || !( ZusammenfassungCtrl.employee.result.final.gap.rente_ausgleich &gt;= ZusammenfassungCtrl.employee.result.final.gap.rente )\"\u003E pro Monat\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cspan ng-if=\"ZusammenfassungCtrl.neoProject.project.compensationRente\"\u003E- Diese Lücke können Sie freiwillig ausgleichen.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns medium-6\"\u003EBei Arbeitslosigkeit (Arbeitslosengeld 1)\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-6 right-text\"\u003E\u003Cspan class=\"green\" ng-if=\"ZusammenfassungCtrl.neoProject.project.compensationALV\"\u003E{{ ZusammenfassungCtrl.employee.result.final.gap.alos | currency }}\u003C\u002Fspan\u003E\u003Cspan ng-if=\"ZusammenfassungCtrl.neoProject.project.compensationALV\"\u003E pro Monat\u003C\u002Fspan\u003E\u003Cspan class=\"red\" ng-if=\"!ZusammenfassungCtrl.neoProject.project.compensationALV\"\u003E{{ ZusammenfassungCtrl.employee.result.final.gap.alos | currency }}\u003C\u002Fspan\u003E\u003Cspan ng-if=\"!ZusammenfassungCtrl.neoProject.project.compensationALV\"\u003E pro Monat\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cspan ng-if=\"ZusammenfassungCtrl.neoProject.project.compensationALV\"\u003E- Diese Lücke wird durch Ihren Arbeitgeber ausgeglichen.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns medium-6\"\u003EBei Krankheit (länger als 6 Wochen)\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-6 right-text\"\u003E\u003Cspan class=\"green\" ng-if=\"ZusammenfassungCtrl.neoProject.project.compensationALV\"\u003E{{ (ZusammenfassungCtrl.employee.result.final.gap.ktg \u002F 30) | currency }}\u003C\u002Fspan\u003E\u003Cspan ng-if=\"ZusammenfassungCtrl.neoProject.project.compensationALV\"\u003E pro Krankheitstag\u003C\u002Fspan\u003E\u003Cspan class=\"red\" ng-if=\"!ZusammenfassungCtrl.neoProject.project.compensationALV\"\u003E{{ (ZusammenfassungCtrl.employee.result.final.gap.ktg \u002F 30) | currency }}\u003C\u002Fspan\u003E\u003Cspan ng-if=\"!ZusammenfassungCtrl.neoProject.project.compensationALV\"\u003E pro Krankheitstag\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cspan ng-if=\"ZusammenfassungCtrl.neoProject.project.compensationALV\"\u003E- Diese Lücke wird durch Ihren Arbeitgeber ausgeglichen.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"margin-top-big\"\u003E&nbsp;\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"ZusammenfassungCtrl.testmode\"\u003E\u003Cdiv class=\"form-group schema-form-submit continue-margin-top\" overlay=\"ZusammenfassungCtrl.documentLoading\"\u003E\u003Cdiv class=\"left\" ng-if=\"!ZusammenfassungCtrl.employeeBlocked\"\u003E\u003Cbutton class=\"btn btn-primary\" ng-if=\"ZusammenfassungCtrl.testmode\" ng-click=\"ZusammenfassungCtrl.getDocument(99)\"\u003E{{ ZusammenfassungCtrl.DocumentConstants[99].name }}\u003C\u002Fbutton\u003E" + (pug.escape(null == (pug_interp = ' ') ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003Cspan class=\"error\" ng-if=\"!ZusammenfassungCtrl.is_calculation_finalization_allowed &amp;&amp; !ZusammenfassungCtrl.documentLoading\"\u003EDer Abruf von Mobiltelefon in Verbindung mit PC-Leasing ist aktuell nicht möglich. Sie verfügen über kein geeignetes PC-Leasing.\u003C\u002Fspan\u003E\u003Cspan class=\"error\" ng-if=\"ZusammenfassungCtrl.has_overlapping_components_with_bonus_result.overall\"\u003EDie folgenden Bausteine werden bereits verwendet: {{ ZusammenfassungCtrl.has_overlapping_components_with_bonus_result.validations.components }}.\u003C\u002Fspan\u003E\u003Cbutton class=\"btn btn-primary right\" ng-click=\"ZusammenfassungCtrl.proceed()\" ng-disabled=\"!ZusammenfassungCtrl.canCheckout()\"\u003EWeiter\u003C\u002Fbutton\u003E\u003Cdiv class=\"clearfix\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"clearfix\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"bigbox\" ng-show=\"ZusammenfassungCtrl.visibleMpp\"\u003E\u003Cdiv class=\"header\"\u003E\u003Cspan\u003EPC-Leasing Details\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"main\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns small-12\"\u003E\u003Cdiv class=\"mainWrapper\"\u003E\u003Cp class=\"error-text\" ng-show=\"ZusammenfassungCtrl.mppError\"\u003EEiner oder mehrere Artikel in Ihrem Warenkorb sind nicht mehr verfügbar oder gültig.\u003C\u002Fp\u003E\u003Cp class=\"error-text\" ng-show=\"ZusammenfassungCtrl.custMPP\"\u003ELeider ist derzeit eine Beantragung mit dem Baustein PC Leasing nicht möglich.\u003C\u002Fp\u003E\u003Cdiv ng-if=\"ZusammenfassungCtrl.iAmSpecialAdvisor\"\u003E";
pug_mixins["checkbox"].call({
attributes: {"key": "ZusammenfassungCtrl.mppError","title": "Warenkorb muss überprüft werden"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"vn-table\"\u003E\u003Ctable\u003E\u003Ctbody\u003E\u003Ctr\u003E\u003Ctd\u003E\u003Cspan\u003EUmwandlungsrate\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Cspan\u003E{{ ZusammenfassungCtrl.mppBasket.leasing | currency }}\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr\u003E\u003Ctd\u003E\u003Cspan\u003EGesamtsumme Brutto\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Cspan\u003E{{ ZusammenfassungCtrl.mppBasket.brutto_base | currency }}\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003C\u002Ftbody\u003E\u003C\u002Ftable\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns small-12 side-effect\"\u003E\u003Cdiv class=\"side-scrollable\"\u003E\u003Ctable\u003E\u003Ctr\u003E\u003Cth\u003EPosition\u003C\u002Fth\u003E\u003Cth\u003EArtikelnummer\u003C\u002Fth\u003E\u003Cth\u003EArtikelname\u003C\u002Fth\u003E\u003Cth\u003EAnzahl\u003C\u002Fth\u003E\u003Cth\u003EPreis Gesamt (Brutto)\u003C\u002Fth\u003E\u003C\u002Ftr\u003E\u003Ctr ng-repeat=\"article in ZusammenfassungCtrl.mppBasket.articles\" ng-class-odd=\"odd\"\u003E\u003Ctd\u003E\u003Cp class=\"small\"\u003E{{$index + 1}}\u003C\u002Fp\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Cp class=\"small\"\u003E{{article.Artikelnummer}}\u003C\u002Fp\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Cp class=\"small\"\u003E{{article.Artikelname | limitTo: 30}}\u003C\u002Fp\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Cp class=\"small\"\u003E{{ article.quantity }}\u003C\u002Fp\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Cp class=\"small\"\u003E{{article.price * article.quantity | currency}}\u003C\u002Fp\u003E\u003Cspan ng-if=\"article.newprice\"\u003E\u003Cbr\u003E{{article.newprice * article.quantity | currency}}\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003C\u002Ftable\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"bigbox centered\" ng-if=\"!ZusammenfassungCtrl.testmode &amp;&amp; ZusammenfassungCtrl.isOneToOne\"\u003E\u003Cdiv class=\"header\"\u003E\u003Cspan\u003EAbsicherung\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"main\"\u003E\u003Cdiv class=\"mainWrapper\"\u003E\u003Cp\u003EFür die Absicherung der Lücken stehen Ihnen mehrere Möglichkeiten zur Verfügung.\nSie können selbst entscheiden welche Versorgungslücken Sie wie schließen möchten.\u003C\u002Fp\u003E\u003Cp ng-if=\"ZusammenfassungCtrl.neoProject.project.compensationALV\"\u003EDa Ihr Arbeitgeber den Ausgleich der Lücken in den Bereichen Arbeitslosigkeit und Krankengeld übernimmt, wählen Sie bitte zwischen den Varianten A und B.\n\u003C\u002Fp\u003E\u003Cdiv class=\"table-wrapper\"\u003E\u003Ctable\u003E\u003Ctr\u003E\u003Cth\u003E&nbsp;\u003C\u002Fth\u003E\u003Cth\u003EVariante A\u003Cbr\u003EVoller Vorteil\u003C\u002Fth\u003E\u003Cth\u003EVariante B\u003Cbr\u003EAusgleich Rente\u003C\u002Fth\u003E\u003Cth\u003EVariante C\u003Cbr\u003EAusgleich ALV\u002FKTG\u003C\u002Fth\u003E\u003Cth\u003EVariante D\u003Cbr\u003EVolle Absicherung\u003C\u002Fth\u003E\u003C\u002Ftr\u003E\u003Ctr\u003E\u003Cth\u003EVorteil p.a.\u003C\u002Fth\u003E\u003Ctd ng-class=\"{green: ZusammenfassungCtrl.results.a.advantagePerYear &gt;= 0, red: ZusammenfassungCtrl.results.a.advantagePerYear &lt; 0}\"\u003E{{ ZusammenfassungCtrl.results.a.advantagePerYear | currency }}\u003C\u002Ftd\u003E\u003Ctd ng-class=\"{green: ZusammenfassungCtrl.results.b.advantagePerYear &gt;= 0, red: ZusammenfassungCtrl.results.b.advantagePerYear &lt; 0}\"\u003E{{ ZusammenfassungCtrl.results.b.advantagePerYear | currency }}\u003C\u002Ftd\u003E\u003Ctd ng-class=\"{green: ZusammenfassungCtrl.results.c.advantagePerYear &gt;= 0, red: ZusammenfassungCtrl.results.c.advantagePerYear &lt; 0}\"\u003E{{ ZusammenfassungCtrl.results.c.advantagePerYear | currency }}\u003C\u002Ftd\u003E\u003Ctd ng-class=\"{green: ZusammenfassungCtrl.results.d.advantagePerYear &gt;= 0, red: ZusammenfassungCtrl.results.d.advantagePerYear &lt; 0}\"\u003E{{ ZusammenfassungCtrl.results.d.advantagePerYear | currency }}\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr\u003E\u003Cth\u003ERente\u003C\u002Fth\u003E\u003Ctd ng-class=\"{green: ZusammenfassungCtrl.results.a.pension &lt;= 0, red: ZusammenfassungCtrl.results.a.pension &gt; 0}\"\u003E{{ ZusammenfassungCtrl.results.a.pension | currency }}\u003C\u002Ftd\u003E\u003Ctd ng-class=\"{green: ZusammenfassungCtrl.results.b.pension &lt;= 0, red: ZusammenfassungCtrl.results.b.pension &gt; 0}\"\u003E{{ ZusammenfassungCtrl.results.b.pension | currency }}\u003C\u002Ftd\u003E\u003Ctd ng-class=\"{green: ZusammenfassungCtrl.results.c.pension &lt;= 0, red: ZusammenfassungCtrl.results.c.pension &gt; 0}\"\u003E{{ ZusammenfassungCtrl.results.c.pension | currency }}\u003C\u002Ftd\u003E\u003Ctd ng-class=\"{green: ZusammenfassungCtrl.results.d.pension &lt;= 0, red: ZusammenfassungCtrl.results.d.pension &gt; 0}\"\u003E{{ ZusammenfassungCtrl.results.d.pension | currency }}\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr\u003E\u003Cth\u003EArbeitslosengeld\u003C\u002Fth\u003E\u003Ctd ng-class=\"{green: (ZusammenfassungCtrl.results.a.alos &lt;= 0 || ZusammenfassungCtrl.neoProject.project.compensationALV), red: ZusammenfassungCtrl.results.a.alos &gt; 0}\"\u003E{{ ZusammenfassungCtrl.results.a.alos | currency }}\u003C\u002Ftd\u003E\u003Ctd ng-class=\"{green: (ZusammenfassungCtrl.results.b.alos &lt;= 0 || ZusammenfassungCtrl.neoProject.project.compensationALV), red: ZusammenfassungCtrl.results.b.alos &gt; 0}\"\u003E{{ ZusammenfassungCtrl.results.b.alos | currency }}\u003C\u002Ftd\u003E\u003Ctd ng-class=\"{green: ZusammenfassungCtrl.results.c.alos &lt;= 0, red: ZusammenfassungCtrl.results.c.alos &gt; 0}\"\u003E{{ ZusammenfassungCtrl.results.c.alos | currency }}\u003C\u002Ftd\u003E\u003Ctd ng-class=\"{green: ZusammenfassungCtrl.results.d.alos &lt;= 0, red: ZusammenfassungCtrl.results.d.alos &gt; 0}\"\u003E{{ ZusammenfassungCtrl.results.d.alos | currency }}\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr\u003E\u003Cth\u003EKrankengeld\u003C\u002Fth\u003E\u003Ctd ng-class=\"{green: (ZusammenfassungCtrl.results.a.ktg &lt;= 0 || ZusammenfassungCtrl.neoProject.project.compensationALV), red: ZusammenfassungCtrl.results.a.ktg &gt; 0}\"\u003E{{ ZusammenfassungCtrl.results.a.ktg | currency }}\u003C\u002Ftd\u003E\u003Ctd ng-class=\"{green: (ZusammenfassungCtrl.results.b.ktg &lt;= 0 || ZusammenfassungCtrl.neoProject.project.compensationALV), red: ZusammenfassungCtrl.results.b.ktg &gt; 0}\"\u003E{{ ZusammenfassungCtrl.results.b.ktg | currency }}\u003C\u002Ftd\u003E\u003Ctd ng-class=\"{green: ZusammenfassungCtrl.results.c.ktg &lt;= 0, red: ZusammenfassungCtrl.results.c.ktg &gt; 0}\"\u003E{{ ZusammenfassungCtrl.results.c.ktg | currency }}\u003C\u002Ftd\u003E\u003Ctd ng-class=\"{green: ZusammenfassungCtrl.results.d.ktg &lt;= 0, red: ZusammenfassungCtrl.results.d.ktg &gt; 0}\"\u003E{{ ZusammenfassungCtrl.results.d.ktg | currency }}\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr\u003E\u003Cth\u003EIhre Auswahl\u003C\u002Fth\u003E\u003Ctd\u003E";
pug_mixins["radio"].call({
attributes: {"id": "ZusammenfassungCtrl.coverageChoicesA","key": "ZusammenfassungCtrl.adjustment.coverageChoice","ng-value": "'A'","readonly": "ZusammenfassungCtrl.documentLoading","data-cy": "neo.checkout.basicComponents.overview.checkOptionA"}
});
pug_html = pug_html + "\u003Clabel for=\"ZusammenfassungCtrl.coverageChoicesA\"\u003E\u003C\u002Flabel\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E";
pug_mixins["radio"].call({
attributes: {"id": "ZusammenfassungCtrl.coverageChoicesB","key": "ZusammenfassungCtrl.adjustment.coverageChoice","data-cy": "neo.checkout.basicComponents.overview.checkOptionB","ng-value": "'B'","readonly": "ZusammenfassungCtrl.documentLoading || ZusammenfassungCtrl.avbB"}
});
pug_html = pug_html + "\u003Clabel for=\"ZusammenfassungCtrl.coverageChoicesB\"\u003E\u003C\u002Flabel\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E";
pug_mixins["radio"].call({
attributes: {"id": "ZusammenfassungCtrl.coverageChoicesC","key": "ZusammenfassungCtrl.adjustment.coverageChoice","data-cy": "neo.checkout.basicComponents.overview.checkOptionC","ng-value": "'C'","readonly": "ZusammenfassungCtrl.documentLoading || ZusammenfassungCtrl.avbC"}
});
pug_html = pug_html + "\u003Clabel for=\"ZusammenfassungCtrl.coverageChoicesC\"\u003E\u003C\u002Flabel\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E";
pug_mixins["radio"].call({
attributes: {"id": "ZusammenfassungCtrl.coverageChoicesD","key": "ZusammenfassungCtrl.adjustment.coverageChoice","data-cy": "neo.checkout.basicComponents.overview.checkOptionD","ng-value": "'D'","readonly": "ZusammenfassungCtrl.documentLoading || ZusammenfassungCtrl.avbD "}
});
pug_html = pug_html + "\u003Clabel for=\"ZusammenfassungCtrl.coverageChoicesD\"\u003E\u003C\u002Flabel\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003C\u002Ftable\u003E\u003C\u002Fdiv\u003E\u003Cp ng-if=\"ZusammenfassungCtrl.madeUser\"\u003EBitte treffen Sie Ihre Entscheidung durch Klicken Ihrer gewünschten Auswahl. Fahren Sie fort mit dem Klick auf WEITER.\u003C\u002Fp\u003E\u003Cp ng-if=\"!ZusammenfassungCtrl.madeUser\"\u003EDieser Nutzer hat noch keinen Account für das Portal. Jetzt" + (pug.escape(null == (pug_interp = ' ') ? "" : pug_interp)) + "\u003Ca ng-click=\"ZusammenfassungCtrl.arbeitnehmerFreischalten()\"\u003Eanlegen?\u003C\u002Fa\u003E\u003C\u002Fp\u003E\u003Cdiv ng-if=\"!ZusammenfassungCtrl.iAmSpecialAdvisor &amp;&amp; (( ZusammenfassungCtrl.iAmAdvisor &amp;&amp; ZusammenfassungCtrl.employeeBlocked )|| ((ZusammenfassungCtrl.employeeBlocked || ZusammenfassungCtrl.noSelfserviceCheckout) &amp;&amp; !ZusammenfassungCtrl.iAmAdvisor))\"\u003E\u003Chr\u003E\u003Cspan class=\"error\"\u003EDer Beantragungsprozess kann hier nicht fortgeführt werden.\u003C\u002Fspan\u003E\u003Cp ng-if=\"(ZusammenfassungCtrl.noSelfserviceCheckout &amp;&amp; (!ZusammenfassungCtrl.iAmAdvisor ||  !ZusammenfassungCtrl.iAmSpecialAdvisor) )\"\u003EFür eine Beantragung von Bausteinen nehmen Sie bitte Kontakt mit Ihrem zuständigen Berater auf.\u003C\u002Fp\u003E\u003Cp\u003ESollten Sie Anpassungswünsche an einer bestehenden Optimierung haben oder an einer vor kurzem bestellten Warenkorb, so nutzen Sie bitte die Funktion \"Support kontaktieren\" im Nutzermenü.\n\u003C\u002Fp\u003E\u003Cdiv overlay=\"berater.orderBusy\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group schema-form-submit continue-margin-top\" overlay=\"ZusammenfassungCtrl.documentLoading\"\u003E\u003Cdiv class=\"left\" ng-if=\"!ZusammenfassungCtrl.employeeBlocked\"\u003E\u003Cbutton class=\"btn btn-primary\" ng-if=\"ZusammenfassungCtrl.testmode\" ng-click=\"ZusammenfassungCtrl.getDocument(99)\"\u003E{{ ZusammenfassungCtrl.DocumentConstants[99].name }}\u003C\u002Fbutton\u003E\u003C!--=' '--\u003E\u003C\u002Fdiv\u003E\u003Cspan class=\"error\" ng-if=\"!ZusammenfassungCtrl.is_calculation_finalization_allowed &amp;&amp; !ZusammenfassungCtrl.documentLoading\"\u003EDer Abruf von Mobiltelefon in Verbindung mit PC-Leasing ist aktuell nicht möglich. Sie verfügen über kein geeignetes PC-Leasing.\u003C\u002Fspan\u003E\u003Cspan class=\"error\" ng-if=\"ZusammenfassungCtrl.has_overlapping_components_with_bonus_result.overall\"\u003EDie folgenden Bausteine werden bereits verwendet: {{ ZusammenfassungCtrl.has_overlapping_components_with_bonus_result.validations.components }}.\u003C\u002Fspan\u003E\u003Cbutton class=\"btn btn-primary right\" ng-click=\"ZusammenfassungCtrl.proceed()\" ng-disabled=\"!ZusammenfassungCtrl.canCheckout()\" data-cy=\"neo.checkout.basicComponents.overview.buttonNext\"\u003EWeiter\u003C\u002Fbutton\u003E\u003Cdiv class=\"clearfix\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"clearfix\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"bigbox centered\" ng-if=\"!(!ZusammenfassungCtrl.testmode &amp;&amp; ZusammenfassungCtrl.isOneToOne)\"\u003E\u003Cdiv class=\"header\"\u003E\u003Cspan\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"main\"\u003E\u003Cdiv class=\"mainWrapper\" overlay=\"ZusammenfassungCtrl.documentLoading\"\u003E\u003Cdiv ng-if=\"ZusammenfassungCtrl.employeeBlocked || !ZusammenfassungCtrl.canCheckout()\"\u003E\u003Chr\u003E\u003Cspan class=\"error\"\u003EDer Checkout ist leider nicht möglich.\u003C\u002Fspan\u003E\u003Cp\u003ESollten Sie Anpassungswünsche an einer bestehenden Optimierung haben, so nutzen Sie bitte die Funktion \"Support kontaktieren\" im Nutzermenü.\n\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cspan class=\"error\" ng-if=\"!ZusammenfassungCtrl.is_calculation_finalization_allowed &amp;&amp; !ZusammenfassungCtrl.documentLoading\"\u003EDer Abruf von Mobiltelefon in Verbindung mit PC-Leasing ist aktuell nicht möglich. Sie verfügen über kein geeignetes PC-Leasing.\u003C\u002Fspan\u003E\u003Cspan class=\"error\" ng-if=\"ZusammenfassungCtrl.has_overlapping_components_with_bonus_result.overall\"\u003ECan not start checkout - you are already using components {{ ZusammenfassungCtrl.has_overlapping_components_with_bonus_result.validations.components }}. ##translate\u003C\u002Fspan\u003E\u003Cbutton class=\"btn btn-primary right\" ng-click=\"ZusammenfassungCtrl.proceed()\" ng-disabled=\"!ZusammenfassungCtrl.canCheckout()\"\u003EWeiter\u003C\u002Fbutton\u003E\u003Cdiv class=\"clearfix\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"clearfix\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }.call(this, "fieldsetCounter" in locals_for_with ?
        locals_for_with.fieldsetCounter :
        typeof fieldsetCounter !== 'undefined' ? fieldsetCounter : undefined, "globals" in locals_for_with ?
        locals_for_with.globals :
        typeof globals !== 'undefined' ? globals : undefined, "id" in locals_for_with ?
        locals_for_with.id :
        typeof id !== 'undefined' ? id : undefined));
    ;;return pug_html;};
module.exports = template;